import React, {Component} from 'react';

class SupportCoinGrasp extends Component {
    render() {
        return (
            <div className="support-coingrasp">
                <div className="support-coingrasp-title">Help us keep the site running</div>
                <p>
                    <span className={'cg-icon cg-icon-BTC'}/><span className="cg-symbol">BTC</span>
                    <input type="text" value="14hcNGhj8GoXXF9uq2zDL9hAEwNdkzG66D" readOnly="readOnly"/>
                </p>
                <p>
                    <span className={'cg-icon cg-icon-BCH'}/><span className="cg-symbol">BCH</span>
                    <input type="text" value="1HD7hMQb4GJZNZp8a1Ev43QgTqj9KXJQAo" readOnly="readOnly"/>
                </p>
                <p>
                    <span className={'cg-icon cg-icon-ETH'}/><span className="cg-symbol">ETH</span>
                    <input type="text" value="0xfee7971449cfddb72230a035b1f72ec6b964804c" readOnly="readOnly"/>
                </p>
                <p>
                    <span className={'cg-icon cg-icon-LTC'}/><span className="cg-symbol">LTC</span>
                    <input type="text" value="LdZiYGMdPT2NNQmW4N1A5QMRL2Fy31enFq" readOnly="readOnly"/>
                </p>

                <div className="support-coingrasp-subtitle">Any amount is <strong>greatly</strong> appreciated.</div>
            </div>
        );
    }
}

export default SupportCoinGrasp;


// WEBPACK FOOTER //
// ./src/SupportCoinGrasp.js